import "./normalTextStyle.css"

export default function NormalText({text, elipses}) {
    return (
        <p className={elipses ? "normal-text elipses" : "normal-text"}>{text}</p>
    );
}